module.exports = __webpack_public_path__ + "static/media/IMG_20190130_112120637.437f372e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/IMG_20190130_112120637.jpg
// module id = 39
// module chunks = 0